import LocalizedStrings from 'react-localization';

export class Locale {
  static configure(config) {
    this.strings = new LocalizedStrings(config);
  }

  static t(key) {
    return this.strings[key];
  }
}

export const i18n = (key) => (Locale.t(key))
